import { SuggestedQuoteChange } from 'types/suggestions/QuoteSuggestions';

// Values match the API's handledState field.
export enum QuoteHandledState {
  Active = 'active',
  Quoted = 'quoted',
  Replied = 'replied',
  Skipped = 'skipped',
}

// Why the backend assigned a handled state.
export enum QuoteHandledReason {
  Reply = 'reply',
  SiblingReply = 'sibling_reply',
  DrumkitQuote = 'drumkit_quote',
  Dismissed = 'dismissed',
  Stale = 'stale',
}

// States shown in collapsed handled groups.
export type HandledGroupState =
  | QuoteHandledState.Replied
  | QuoteHandledState.Quoted
  | QuoteHandledState.Skipped;

// Lanes from one source email.
export type QuoteRequestBatch = SuggestedQuoteChange[];

export type HandledQuoteGroupsData = Record<
  HandledGroupState,
  QuoteRequestBatch[]
>;

export type PartitionedQuoteRequests = {
  active: SuggestedQuoteChange[];
  handled: HandledQuoteGroupsData;
  // Lanes per source email across every state. Nothing renders it since the batch header was removed.
  laneCountByEmailID: Record<number, number>;
};
